<template>

	<div>
		<Card>
			<Form ref="formInline" :model="formInline" :rules="ruleInline" inline label-position="right">
				<FormItem :label="$tt('充电场站')" prop="StationId" :label-width="70">
					<Select filterable :placeholder="$tt('站点列表')" style="width:150px" v-model="formInline.StationId">
						<Option :value=0>{{$tt('全部')}}</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$tt('设备编号')" prop="EquipmentNo" :label-width="70">
					<Input style="width: 150px;" type="text" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')">
					<!-- <span slot="prepend">{{$tt('设备编号')}}</span> -->
					</Input>
				</FormItem>
				<FormItem prop="trackName" :label="$tt('设备序列号')" :label-width="90">
					<Input type="text" v-model="formInline.EquipmentSerialNo" :placeholder="$tt('设备序列号')" />
				</FormItem>
				<!-- <FormItem :label="$tt('设备类型')" prop="EquipmentType" :label-width="70">
					<Select :placeholder="$tt('输入设备类型')" style="width:150px" v-model="formInline.EquipmentType">
						<Option :value='1'>{{$tt('直流设备')}}</Option>
						<Option :value='2'>{{$tt('交流设备')}}</Option>
						<Option :value='3'>{{$tt('交直流一体设备')}}</Option>
						<Option :value='4'>{{$tt('无线设备')}}</Option>
						<Option :value='5'>{{$tt('其他')}}</Option>
					</Select>
				</FormItem> -->
				<!-- <FormItem :label="$tt('设备型号')" prop="EquipmentModel" :label-width="70">
					<Input type="text" v-model="formInline.EquipmentModel" :placeholder="$tt('设备型号')">
					</Input>
				</FormItem> -->
				<FormItem>
					<div style="display:flex;flex-wrap:wrap;gap:12px;">
						<Button type="primary" @click="handleSubmit()">{{$tt('查询')}}</Button>
						<Button type="primary" @click="handleDiagnostics()">{{$tt('召测日志')}}</Button>
						<Button type="primary" @click="getEquipLogsList()">{{$tt('刷新日志列表')}}</Button>
					</div>
				</FormItem>
			</Form>
		</Card>
		<Row :gutter="10" class="tables-row">
			<Col class="col-equip-table">
			<div style="margin: 0; padding: 0;">
				<Table ref="equipSelection" border :columns="equipColumns" size="small" :data="equipDatas" :height="tableEquipHeight"
					@on-select="onEquipSelect" :loading="tableLoading || equipLoading">
					<!-- <template #result="{ row }">
						<Alert v-if="row.Result == 1" type="success">
							<Icon type="md-checkmark-circle" color="#19be6b" />{{$tt('成功')}}
						</Alert>
						<Alert v-if="row.Result == 2" type="error">
							<Icon type="md-close-circle" color="#ed4014" />{{ row.ResultMsg }}
						</Alert>
					 -->
					<MyPage slot="footer" ref="equipPageList" :param="formInline" :url="getEquipmentInfoUrl"
						@listData='getDeviceList'></MyPage>
				</Table>
			</div>
			</Col>
			<Col class="col-param-item-table">
			<div :style="`margin: 0; padding: 0; font-size: 12px; height: ${tableParamItemHeight}px;`">
				<Table row-key="RowKey" border resizable :columns="fileInfoColomns" :data="dateItemDatas" size="small"
					:height="tableParamItemHeight" :loading="tableLoading">
					<!-- 
						<strong>{{ row.DataName }}</strong>
					 -->
					
						<Row :gutter="15" justify="center" align="middle" style="display: flex;">
							<Col :span="12"
								style="display: flex; flex-direction: column; justify-content: center; justify-items: center;">
							<Button type="primary" @click="viewFile(row)" size="small">{{$tt('查看')}}</Button>
							</Col>
							<Col :span="12"
								style="display: flex; flex-direction: column; justify-content: center; justify-items: center;">
							<Button type="primary" @click="downloadFile(row)" size="small">{{$tt('下载')}}</Button>
							</Col>
						</Row>
					
				</Table>
			</div>
			</Col>
		</Row>
		<Modal :mask-closable="false" v-model="modalView" :title="$tt('查看日志')" width="40%" style="height: 75vh">
			<!--设备安装和设备修改-->
			<Input v-model="fileContent" readonly type="textarea" placeholder="" style="height: 100%;" />   
		</Modal>
	</div>
</template>
</template>

<script>
	import {
		mapState,
	} from 'vuex';
	import webapi from '../../../webapi';
	// import dateFormat from '../../../../public/js/comm.js';
	export default {
		data() {
			return {
				getEquipmentInfoUrl: webapi.base_api_url + '/System/GetEquipmentInfo',
				tableHeight: 0,
				tableEquipHeight: 0,
				tableParamItemHeight: 0,
				tableLoading: false,
				equipLoading: false,
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentModel: '',
					EquipmentTypeDesc: '',
					EquipmentSerialNo: '',
				},
				ruleInline: {

				},
				equipColumns: [{
						type: 'selection',
						width: 55
					},
					{
						title: 'ID',
						key: 'ConnectorId',
						width: 80
					},
					{
						title: this.$tt('充电枪编码'),
						key: 'ConnectorNo',
						resizable: true,
						minWidth: 120,
					},
					{
						title: this.$tt('设备序列号'),
						key: 'EquipmentSerialNo',
						resizable: true,
						minWidth: 85,
					},
					{
						title: this.$tt('状态'),
						key: 'WorkStatus',
						minWidth: 50,
						render: (h, params) => {
							return h('div',
								this.$tEnum('EquipmentStatus', params.row.EquipmentStatus, params.row.EquipmentStatusDesc)
							);
						}
					}
				// 	{
				// 		title: '结果',
				// 		slot: 'result',
				// 		width: 120,
				// 		align: 'center'
				// 	}
				],
				equipDatas: [],
				fileInfoColomns: [{
						// type: 'expand',
						title: this.$tt('文件名'),
						key: 'FileName',
						resizable: true,
						tree: true,
						minWidth: 160,
					},
					{
						title: this.$tt('桩编码'),
						key: 'EquipNo',
						resizable: true,
						// key: 'ReadValue'
						minWidth: 150,
					},
					{
						title: this.$tt('设备序列号'),
						//slot: 'writeValue',
						key: 'EquipSerialNo',
						resizable: true,
						minWidth: 150,
					},
					// {
					// 	title: '状态',
					// 	//slot: 'status',
					// 	width: 120,
					// 	key: 'Status',
					// 	align: 'center'
					// },
					{
						title: this.$tt('召测时间'),
						key: 'LogTime',
						resizable: true,
						minWidth: 150,
					},
					{
						title: this.$tt('操作'),
						slot: 'action',
						align: 'center',
						width: 150,
					}
				],
				dateItemDatas: [],
				modalView: false,
				fileContent: '',
			}
		},

		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 170;
			_this.tableEquipHeight = window.innerHeight - 170;
			_this.tableParamItemHeight = window.innerHeight - 170;
			if (window.innerWidth < 1450) {
				_this.tableEquipHeight = 200;
				_this.tableParamItemHeight = window.innerHeight - 170 - _this.tableEquipHeight;
			}
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const _this = this;
			this.getEquipLogsList();
			_this.handleSubmit();
		},
		computed: {
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			handleSubmit: function() {
				const _this = this;
				_this.equipLoading = true;
				_this.$refs.equipPageList.getList().finally(res => {
					_this.equipLoading = false;
				});
			},
			handleDiagnostics: function() {
				const _this = this;
				let selections = _this.$refs.equipSelection.getSelection();
					if (selections.length != 1) {
						this.$Message.warning(this.$tt('必须选择一台桩'));
						return;
					}
					_this.equipLoading = true;
					_this.tableLoading = true;
					_this.$axios.post(webapi.base_api_url + '/System/GetEquipLogs', selections[0]).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.$Message.info(this.$tt('下发命令成功'));
					}					
				}).finally(res => {
					_this.equipLoading = false;
					_this.tableLoading = false;
				});
			},
			getTableHeight: function() {
				const _this = this;
				_this.tableHeight = window.innerHeight - 170;
				_this.tableEquipHeight = window.innerHeight - 170;
				_this.tableParamItemHeight = window.innerHeight - 170;
				if (window.innerWidth < 1450) {
					_this.tableEquipHeight = 200;
					_this.tableParamItemHeight = window.innerHeight - 170 - _this.tableEquipHeight;
				}
				_this.tableParamItemHeight = Math.max(300, _this.tableParamItemHeight);
			},
			getEquipLogsList: function() {
				const _this = this;
				_this.tableLoading = true;
				
				this.$axios.post(webapi.base_api_url + '/System/GetEquipLogsRecord', _this.formInline).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.dateItemDatas = res.data.Data.List;
					}
				}).finally(res => {
					_this.tableLoading = false;
				});
			},
			viewFile: function(param) {
				const _this = this;
				_this.tableLoading = true;

				this.$axios.post(webapi.base_api_url + '/System/ViewEquipLogFile', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.modalView = true;
						_this.fileContent = res.data.Data;
					}
				}).finally(res => {
					_this.tableLoading = false;
				})
			},
			downloadFile: function(param) {
				const _this = this;
				_this.tableLoading = true;

				this.$axios.post(webapi.base_api_url + '/System/DownloadEquipLogFile', param, { responseType: 'blob' }).then(res => {
					if (res.status == 200) {
						const disposition = res.headers['content-disposition'];
						let fileName = param.FileName;
						if (disposition) {
							const match = disposition.match(/filename\*=utf-8''([^;]+)/i);
							if (match) fileName = decodeURIComponent(match[1]);
						}
						
						const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
						const a = document.createElement('a');
						a.href = URL.createObjectURL(blob);
						a.download = fileName;
						document.body.appendChild(a);
						a.click();
						requestAnimationFrame(() => {
							// 释放内存
							URL.revokeObjectURL(a.href);
							document.body.removeChild(a);
						});
					}
				}).finally(res => {
					_this.tableLoading = false;
				})
			},
			getDeviceList: function(data) {
				this.equipDatas = data.Data.List.map(obj => {
					return {
						...obj,
						Result: ''
					}
				});
			},
			// showReadValue(data) {
			// 	if (data.ReadAble == 0 || data.ReadValue == '') return '';
			// 	if (data.WidgetType == 2) {
			// 		for (let i = 0; i < data.WidgetOptionalDefine.length; i++) {
			// 			if (data.WidgetOptionalDefine[i].Value == data.ReadValue) {
			// 				return data.WidgetOptionalDefine[i].Text;
			// 			}
			// 		}
			// 	} else if (data.WidgetType == 4) {
			// 		if (data.ReadValue == 1) return '启用';
			// 		else return '停用'
			// 	}
			// 	return data.ReadValue;
			// },
			onEquipSelect(selection, row) {
				for (let i = 0; i < this.equipDatas.length; i++) {
					let index = selection.findIndex(v => v.ConnectorId == this.equipDatas[i].ConnectorId);
					this.equipDatas[i]._checked = (index != -1);
				}
			},
			// onDateChange(value, a, b, c) {
			// 	console.log(value, a, b, c);
			// }
		}
	}
</script>

<style scoped>
	/* 	ivu-table, .h-table {
		height: calc(100vh - 200px);
	} */

	/deep/.ivu-form-item {
		margin-bottom: 0;
	}

	/deep/.ivu-alert {
		margin-bottom: 0;
		padding: 8px 0px;
	}

	/* 	/deep/.ivu-table-body {
		overflow-y: scroll;
	} */

	/* 	/deep/.ivu-table-cell {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	} */
	.cell-div {
		height: 100% !important;
		width: 100% !important;
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
	
	/deep/.col-equip-table {
		width: 100%;
	}
	/deep/.col-param-item-table {
		width: 100%;
	}
	@media (min-width: 1450px) {
		/deep/.tables-row {
			flex-wrap: nowrap;
		}
		/deep/.col-equip-table {
			width: 500px !important;
		}
		/deep/.col-param-item-table {
			width: calc(100% - 500px) !important;
		}
	}
	/deep/.ivu-modal-body {
		height: 75vh;
		textarea {
			height: 100%;
		}
	}
</style>
